<script>
import {formatZonedDateTime, openDocument} from "@/baseUtils";
import {mapActions} from "pinia";
import {baseLoaderStore} from "@/store/baseLoaderStore";
import i18n from "@/i18n";

export default {
  name: "SourceListItem",
  props: {
    itemData: {
      type: Object
    }
  },
  computed: {
    sourceContent() {
      return this.itemData.source.source.content
    },
    contentType() {
      return this.sourceContent.type;
    },
    contentTypeLabel() {
      return this.contentType.toLowerCase()
    },
    itemDateLabel() {
      return this.itemData.version > 1 ? i18n.global.t('mainSearch.updated') : i18n.global.t('mainSearch.registered');
    },
    sourceCreateDate() {
      return formatZonedDateTime(this.itemData.createdTime);
    }
  },
  methods: {
    ...mapActions(baseLoaderStore, [
      'showBaseLoader',
      'hideBaseLoader'
    ]),
    getDocument() {
      const type = this.itemData.source.source.content.type;
      const hash = this.itemData.source.source.content.attachments[0].hash;

      this.showBaseLoader();
      openDocument(hash, type).then(()=> {
        this.hideBaseLoader();
      });
    },
  }
}
</script>

<template>
  <div class="source-list-item">
    <span class="source-title" @click="getDocument()">
      {{itemData.source.source.content.title}}
    </span>
    <div class="info-row">
      <span class="info-text mr-5">{{$t('mainSearch.source.author')}}</span>
      <router-link :to="{name: 'UserView', params: {id: itemData.creator.id}}"
                   target="_blank"
                   class="info-label"
      >{{itemData.creator.name}}</router-link>
    </div>
    <div class="info-row">
      <span class="info-text">{{itemDateLabel}} {{sourceCreateDate}}</span>
      <font-awesome-icon :icon="['fas', 'circle']"
                         class="dot-separator"
      />
      <template v-if="contentType === 'VIDEO'">
        <div class="doc-type">
          <font-awesome-icon :icon="['fas', 'play']"
                             class="doc-type__icon"
          />
          <span class="doc-type__text">{{ contentTypeLabel }}</span>
        </div>
      </template>
      <template v-else-if="contentType === 'PDF'">
        <div class="doc-type">
          <font-awesome-icon :icon="['fas', 'file-pdf']"
                             class="doc-type__icon"
          />
          <span class="doc-type__text">{{ contentTypeLabel }}</span>
        </div>
      </template>
      <template v-else-if="contentType === 'DOCX'">
        <div class="doc-type">
          <font-awesome-icon :icon="['fas', 'file-word']"
                             class="doc-type__icon"
          />
          <span class="doc-type__text">{{ contentTypeLabel }}</span>
        </div>
      </template>
      <template v-else-if="contentType === 'EXCEL'">
        <div class="doc-type">
          <font-awesome-icon :icon="['fas', 'file-excel']"
                             class="doc-type__icon"
          />
          <span class="doc-type__text">{{ contentTypeLabel }}</span>
        </div>
      </template>
      <template v-else-if="contentType === 'PRESENTATION'">
        <div class="doc-type">
          <font-awesome-icon :icon="['fas', 'file-powerpoint']"
                             class="doc-type__icon"
          />
          <span class="doc-type__text">{{ contentTypeLabel }}</span>
        </div>
      </template>
      <template v-else-if="contentType === 'HTML_TEXT'">
        <div class="doc-type">
          <font-awesome-icon :icon="['fas', 'file']"
                             class="doc-type__icon"
          />
          <span class="doc-type__text">{{ contentTypeLabel }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.source-list-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  padding: 12px;
  position: relative;
  max-width: 600px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(79, 79, 79, .15);

  .source-title {
    display: inline-block;
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 600;
    line-height: normal;
    color: #7835a6;
    cursor: pointer;
  }

  .doc-type {
    &__icon {
      margin-right: 5px;
      font-size: 11px;
      font-weight: 600;
      color: #4f4f4f;
      display: inline-block;
      font-style: normal;
      font-variant: normal;
      text-rendering: auto;
      line-height: 1;
    }
    &__text {
      font-size: 12px;
      color: #4f4f4f;
    }
  }

  .info-row {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .info-label {
    display: inline-block;
    margin-right: 5px;
    font-weight: 600;
    font-size: 12px;
    color: #7835a6;
  }

  .info-text {
    display: inline-block;
    font-size: 12px;
    color: #4f4f4f;
  }


  .dot-separator {
    font-size: 3px;
    margin: 0 6px;
    color: #4f4f4f;
  }
}

</style>